import EventEmitter from "node-event-emitter";
import PropTypes from "prop-types";
import React from "react";

export const TileConfigContext = React.createContext({
  tileConfig: {},
});

export const TileConfigProvider = React.memo(
  ({ tileConfig = {}, visibleTileEmitter, children }) => {
    return (
      <TileConfigContext.Provider value={{ tileConfig, visibleTileEmitter }}>
        {React.Children.only(children)}
      </TileConfigContext.Provider>
    );
  },
);

TileConfigProvider.propTypes = {
  children: PropTypes.node,
  visibleTileEmitter: PropTypes.instanceOf(EventEmitter).isRequired,
  tileConfig: PropTypes.objectOf(
    PropTypes.shape({
      columns: PropTypes.number.isRequired,
      rows: PropTypes.number.isRequired,
    }).isRequired,
  ).isRequired,
};

export function useTileConfig() {
  return React.useContext(TileConfigContext).tileConfig;
}

export function useVisibleTileEmitter() {
  return React.useContext(TileConfigContext).visibleTileEmitter;
}

export const WithTileConfig = ({ children, videoId }) => {
  return children({ tileConfig: useTileConfig(videoId) });
};
